export enum PublicProofOfDeliveryEndpoint {
  Base = '/automotive-aftermarket',
  Monitoring = '/monitoring',
  DeliveryNote = '/delivery-note',
  ProofOfDelivery = '/proof-of-delivery',
  Public = '/public',
  Documents = '/documents',
  Feedback = '/feedback',
}
